export const EQUIPMENT_STATUSES = ['planned','proposed','selected','approved','ordered','delivered','installed','rejected','replaced'];
export const STATUS_LABELS = { planned:'Prévu', proposed:'Proposé', selected:'Sélectionné', approved:'Validé', ordered:'Commandé', delivered:'Livré', installed:'Installé', rejected:'Rejeté', replaced:'Remplacé' };
export const VALUE_TYPES = ['decimal','integer','string','boolean','date','json'];
export const SOURCE_TYPES = ['manual','manufacturer_datasheet','manufacturer_api','manufacturer_website','project','approved','as_built'];
export const DATA_KEY_SUGGESTIONS = ['rated_current','rated_active_power','rated_apparent_power','power_factor','efficiency','rated_voltage','frequency','width','height','depth','weight','ip_rating','ik_rating'];
export const DATA_KEY_LABELS = {
  rated_current: 'Courant nominal',
  rated_active_power: 'Puissance active nominale',
  rated_apparent_power: 'Puissance apparente nominale',
  power_factor: 'Facteur de puissance',
  efficiency: 'Rendement',
  rated_voltage: 'Tension nominale',
  frequency: 'Fréquence',
  width: 'Largeur',
  height: 'Hauteur',
  depth: 'Profondeur',
  weight: 'Poids',
  ip_rating: 'Indice de protection IP',
  ik_rating: 'Indice de protection IK',
};
export const VALUE_TYPE_LABELS = {
  decimal: 'Nombre décimal', integer: 'Nombre entier', string: 'Texte',
  boolean: 'Oui / Non', date: 'Date', json: 'Données structurées (JSON)',
};
export const SOURCE_TYPE_LABELS = {
  manual: 'Saisie manuelle', manufacturer_datasheet: 'Fiche technique fabricant',
  manufacturer_api: 'API du fabricant', manufacturer_website: 'Site du fabricant',
  project: 'Projet', approved: 'Donnée validée', as_built: 'Tel que réalisé',
};
